import { useSidebar } from "./SidebarContext";
import { SidebarTooltip } from "./Tooltip";
import type { TeamMember } from "./types";

interface SidebarMemberListProps {
  members: TeamMember[];
}

export function SidebarMemberList({ members }: SidebarMemberListProps) {
  const { collapsed } = useSidebar();

  return (
    <div className="space-y-px">
      {members.map((member) => {
        const initials = member.name
          .split(" ")
          .map((n) => n[0])
          .join("")
          .slice(0, 2);

        const content = (
          <div
            className={`group/member flex items-center rounded-md transition-all duration-150 hover:bg-card-hover/40 ${
              collapsed
                ? "justify-center px-0 mx-auto w-10 h-8"
                : "gap-2.5 py-[5px] pl-3.5 pr-2"
            }`}
          >
            <div className="relative shrink-0">
              {member.avatarUrl ? (
                <img
                  src={member.avatarUrl}
                  alt={member.name}
                  className="h-5 w-5 rounded-full object-cover"
                />
              ) : (
                <div
                  className="flex h-5 w-5 items-center justify-center rounded-full text-[9px] font-semibold text-white"
                  style={{ backgroundColor: member.avatarColor }}
                >
                  {initials}
                </div>
              )}
              {member.online && (
                <div className="absolute -bottom-px -right-px h-2 w-2 rounded-full border-[1.5px] border-surface bg-emerald-400" />
              )}
            </div>

            {!collapsed && (
              <span className="flex-1 truncate text-[13px] tracking-[-0.01em] text-secondary group-hover/member:text-primary transition-colors">
                {member.name}
              </span>
            )}
          </div>
        );

        if (collapsed) {
          return (
            <SidebarTooltip key={member.name} label={member.name} enabled>
              {content}
            </SidebarTooltip>
          );
        }

        return <div key={member.name}>{content}</div>;
      })}
    </div>
  );
}
